import { render } from "./client-pf.vue?vue&type=template&id=66e21d22"
import script from "./client-pf.vue?vue&type=script&lang=js"
export * from "./client-pf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__